import moment from "moment";

const monthArray = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getDate = (date: string, time: boolean = false) => {
  if (!date) {
    return "";
  }
  if (time) {
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  } else {



    const wrongFormat = date.split("/");
    if (wrongFormat.length === 3) {
      let temp = wrongFormat[0];
      wrongFormat[0] = wrongFormat[1]
      wrongFormat[1] = temp;
      date = wrongFormat.join("/")
    }



    //return moment(date).utc().format("YYYY-MM-DD");
    return moment(date).utc().local().format("YYYY-MM-DD");
  }
  //const dateFormat = "YYYY-MM-DD";
  //const dateTimeFormat = `${dateFormat} HH:mm:ss`;
  //return moment(date).format(time ? dateTimeFormat : dateFormat);
  // return date ? date.split("T")[0] : "";
};

export const getDateWithTzCorrection = (date: any) => {
  // console.log("getDateWithTzCorrection: date = ", date)

  if (!date) {
    return "";
  }
  else if (date === "BLANK") {
    return "BLANK"
  }
  else {
    date = date.split("T")[0];
    const dt = new Date(date);

    // Methods on Date Object will convert from UTC to users timezone
    // Set minutes to current minutes (UTC) + User local time UTC offset
    dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset())
    return `${dt.getDate()} ${monthArray[dt.getMonth()]
      } ${dt.getFullYear()}`;
  }

  //const dateFormat = "YYYY-MM-DD";
  //const dateTimeFormat = `${dateFormat} HH:mm:ss`;
  //return moment(date).format(time ? dateTimeFormat : dateFormat);
  // return date ? date.split("T")[0] : "";
};

// export const getDateFromDateString = (date: string) => {
//   console.log("getDateFromDateString: date = ", date)

//   if (!date) {
//     return "";
//   }
//   else {
//     const datePart = date.split("T")[0];

//     return datePart;
//   }
// };

export const getDateWithTzCorrectionYYYYMMDD = (date: any) => {
  console.log("getDateWithTzCorrectionYYYYMMDD: date = ", date)

  if (!date) {
    return "";
  }
  else {
    date = date.split("T")[0];
    const dt = new Date(date);

    // Methods on Date Object will convert from UTC to users timezone
    // Set minutes to current minutes (UTC) + User local time UTC offset
    dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset())
    return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
  }
};

export const fixMonthDateSwap = (date: any) => {
  console.log("date = ", date);
  // const dateArray = date.split("/");
  // console.log("dateArray = ", dateArray);
  // let temp = dateArray[0];
  // dateArray[0] = dateArray[1];
  // dateArray[1] = temp;
  // console.log("dateArray = ", dateArray);
  // const newDate = dateArray.join("/");
  const dt = new Date(date);
  console.log("newDate, dt = ", date, dt);
  return `${dt.getDate()} ${monthArray[dt.getMonth()]
    } ${dt.getFullYear()}`;
}
/**
 * check email validation
 * @param email input to check email
 * @returns boolean
 */
export const validateEmail = (email: string) => {
  const regex = /^(?:|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4})$/i;
  return regex.test(email);
};

export const groupBy = (objectArray: any[], property: string) => {
  return objectArray.reduce((acc, obj) => {
    let key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};

export const getText = (item: any) => {
  // console.log("item = ", item)
  switch (item.action_name) {
    case "Added":
      return `Added as ${item.designation_name}@${item.store_name
        } with employee number ${item.emp_code} and hire date ${getDateWithTzCorrection(item.date_start)}`;
    case "Transferred":
      return `Transferred from ${item.store_name} to ${item.new_store_name
        } effective date ${getDateWithTzCorrection(item.date_start)}`;
    case "Promoted":
      return `Promoted from ${item.designation_name}@${item.store_name} to ${item.new_designation_name
        }@${item.new_store_name} effective date ${getDateWithTzCorrection(item.date_start)}`;
    case "Removed":
      return `Removed with last working date ${getDateWithTzCorrection(
        item.last_working_date
      )} and termination date ${getDateWithTzCorrection(item.termination_date)} with reason ${item.reason_termination
        } and description ${item.reason_description ? item.reason_description : "-"
        }`;
    case "Activated":
      return `Activated with description ${item.activate_reason ? item.activate_reason : "-"
        }`;
    case "Edited":
      return `Edited ${item.activate_reason ? item.activate_reason : "-" // TODO We need to fetch the reason. Secondly backend needs to send data in reverse chronological order like in Employee log
        }`;
    case "Mailed":
      return `${item.description}`;
    case "Borrowed":
      return `Borrowed to ${item.new_store_name} effective date ${getDateWithTzCorrection(item.date_start)}`;
    case "Returned":
      return `Returned to ${item.store_name} effective date ${getDateWithTzCorrection(item.date_start)}`;
    case "Document Upload Reset":
      return `${item.description}${item.email ? ` by ${item.email}` : ""}`;
    default:
      return "";
  }
};

export const preContent = `
<style>
    table, tr, td {
      border: 1px solid black;
      border-collapse: collapse;
      font-size: 0.8rem;
      font-family: Ventura, sans-serif;
    }
      
    h3 {
        font-size: 1.25rem;
        font-weight: 600;
        font-family: Ventura, sans-serif;
        text-transform: uppercase;
        margin-left: 5%;
        margin-right: 5%;
        }
    p, li,ul, a {
        font-family: Ventura, sans-serif;
                font-size: 1.00rem;
        margin-left: 5%;
        margin-right: 5%;
        font-weight: 400;
    }
</style>
`;
